import axiosInstance from "./axiosInstance";

export const transactionService = {
  getTransactions: async (month, year, userId = null) => {
    const params = { month, year };
    if (userId) params.userId = userId;
    const response = await axiosInstance.get("/transactions", { params });
    return response.data;
  },

  saveTransaction: async (data) => {
    const response = await axiosInstance.post("/transactions", data);
    return response.data;
  },

  saveMonthlyStat: async (data) => {
    const response = await axiosInstance.post(
      "/transactions/monthly-stat",
      data,
    );
    return response.data;
  },

  deleteTransaction: async (id) => {
    const response = await axiosInstance.delete(`/transactions/${id}`);
    return response.data;
  },

  getUsers: async () => {
    const response = await axiosInstance.get("/transactions/users");
    return response.data;
  },

  updateUserPercentage: async (id, profitPercentage) => {
    const response = await axiosInstance.put(`/transactions/users/${id}`, {
      profitPercentage,
    });
    return response.data;
  },
  getStats: async (userIds, months) => {
    const params = {
      userIds: Array.isArray(userIds) ? userIds.join(",") : userIds,
      months: Array.isArray(months) ? months.join(",") : months,
    };
    const response = await axiosInstance.get("/transactions/stats", { params });
    return response.data;
  },

  sendBackup: async ({ month, year } = {}) => {
    const response = await axiosInstance.post("/transactions/send-backup", {
      month,
      year,
    });
    return response.data;
  },

  syncKeitaro: async (data) => {
    const response = await axiosInstance.post(
      "/transactions/sync-keitaro",
      data,
    );
    return response.data;
  },

  syncFluxar: async (data) => (await axiosInstance.post("/transactions/sync-fluxar", data)).data,
  getFluxarGroups: async () => (await axiosInstance.get("/transactions/fluxar/groups")).data,
  updateUserFluxarGroup: async (id, fluxarGroupId) => (await axiosInstance.put(`/transactions/users/${id}/fluxar-group`, { fluxarGroupId })).data,

  getKeitaroGroups: async () => {
    const response = await axiosInstance.get("/transactions/keitaro/groups");
    return response.data;
  },

  getKartaUsers: async () => {
    const response = await axiosInstance.get("/transactions/karta/users");
    return response.data;
  },

  updateUserKeitaroGroup: async (id, keitaroGroupId) => {
    const response = await axiosInstance.put(
      `/transactions/users/${id}/keitaro-group`,
      {
        keitaroGroupId,
      },
    );
    return response.data;
  },

  updateUserKartaId: async (id, kartaId) => {
    const response = await axiosInstance.put(
      `/transactions/users/${id}/karta-id`,
      {
        kartaId,
      },
    );
    return response.data;
  },
};
